import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SET_JIRA_INCIDENT_TABLE_FILTER } from "./mdrConstants";
import ApplicationFilter from "../SysGuard/Dashboard/Components/filters/ApplicationFilter";

const JiraColumnFilterDropdown = ({ filterField, onClose, page, size }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!filterField) return;
    dispatch({
      type: SET_JIRA_INCIDENT_TABLE_FILTER,
      payload: {
        key: filterField,
        values: [],
      },
    });
  }, [page, size]);

  // Map for each Jira table filterable column
  const jiraFilterConfigMap = {
    ticketId: {
      listSelector: (state) =>
        state.mdrReducer.JiraIncidentTableFilterOptions?.ticketId || [],
      selectedSelector: (state) =>
        state.mdrReducer.JiraIncidentTableFilter?.ticketId || [],
      actionType: SET_JIRA_INCIDENT_TABLE_FILTER,
    },
    incidentId: {
      listSelector: (state) =>
        state.mdrReducer.JiraIncidentTableFilterOptions?.incidentId || [],
      selectedSelector: (state) =>
        state.mdrReducer.JiraIncidentTableFilter?.incidentId || [],
      actionType: SET_JIRA_INCIDENT_TABLE_FILTER,
    },
    incidentPriority: {
      listSelector: (state) =>
        state.mdrReducer.JiraIncidentTableFilterOptions?.incidentPriority || [],
      selectedSelector: (state) =>
        state.mdrReducer.JiraIncidentTableFilter?.incidentPriority || [],
      actionType: SET_JIRA_INCIDENT_TABLE_FILTER,
    },
    incidentStatus: {
      listSelector: (state) =>
        state.mdrReducer.JiraIncidentTableFilterOptions?.incidentStatus || [],
      selectedSelector: (state) =>
        state.mdrReducer.JiraIncidentTableFilter?.incidentStatus || [],
      actionType: SET_JIRA_INCIDENT_TABLE_FILTER,
    },
  };

  const handleApply = (selectedItems) => {
    
    dispatch({
      type: SET_JIRA_INCIDENT_TABLE_FILTER,
      payload: {
        key: filterField,
        values: selectedItems,
      },
    });
    onClose();
  };

  const handleClear = () => {
    dispatch({
      type: SET_JIRA_INCIDENT_TABLE_FILTER,
      payload: {
        key: filterField,
        values: [],
      },
    });
    onClose();
  };

  return (
    <div className="jira-filter-dropdown">
      <ApplicationFilter
        filterField={filterField}
        onApply={handleApply}
        onClear={handleClear}
        onCancel={onClose}
        customFilterConfigMap={jiraFilterConfigMap}
      />
    </div>
  );
};

export default JiraColumnFilterDropdown;
